// extracted by mini-css-extract-plugin
export var lg = "_h5-7";
export var md = "_h5-6";
export var placeholderContainer = "_h5-1";
export var placeholderIcon = "_h5-2";
export var productImage = "_h5-0";
export var sm = "_h5-5";
export var xl = "_h5-8";
export var xs = "_h5-4";
export var xxs = "_h5-3";